var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Preact from 'preact';
import { Box } from '@mui/material';
import * as IconButton from './A_IconButton';
import * as Button from './A_Button';
import { Undo, Redo, ViewInAr } from '@mui/icons-material';
import { FloorPlanIcon } from './icons';
export var height = 44;
export var Component = function (p) {
    return (Preact.h(Box, { sx: __assign({ width: '100%', padding: '5px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'white.main', boxSizing: 'border-box' }, p.sx) },
        Preact.h(Box, null, p.undoRedo && (Preact.h(Preact.Fragment, null,
            Preact.h(IconButton.Component, { onClick: p.undoRedo.onUndo, sx: { mr: '5px' }, size: "small", color: "secondary", disabled: p.undoRedo.onUndo === undefined },
                Preact.h(Undo, { fontSize: "medium" })),
            Preact.h(IconButton.Component, { onClick: p.undoRedo.onRedo, sx: { ml: '5px' }, size: "small", color: "secondary", disabled: p.undoRedo.onRedo === undefined },
                Preact.h(Redo, { fontSize: "medium" }))))),
        Preact.h(Box, null,
            Preact.h(Box, null,
                p.onEditFloorplan && (Preact.h(Button.Component, { startIcon: Preact.h(FloorPlanIcon, { fontSize: "small", sx: { width: '18px', height: '18px' } }), size: "small", color: "secondary", variant: "text", onClick: p.onEditFloorplan }, "Edit floorplan")),
                Preact.h(Button.Component, { startIcon: Preact.h(ViewInAr, { fontSize: "small", sx: { width: '18px', height: '18px' } }), size: "small", color: "secondary", variant: "text", onClick: p.onAr }, "AR")))));
};
Component.displayName = 'ActionBarDefault';
